/* eslint-disable no-param-reassign */
import { cloneDeep, forEach, isEmpty, isNil, set } from 'lodash';

/**
 * Applies a style to the video container.
 *
 * @param {object} arg - The arguments for the function.
 * @param {object} arg.videoContainer - The video container to apply the style to.
 * @param {object} arg.videoStyle - The style to apply to the video.
 * @param {object} arg.showVideo - Flag to check if video is shown.
 */
const setVideoStyle = ({ videoContainer, videoStyle, showVideo }) => {
  const styleToApply = cloneDeep(videoStyle);
  if (showVideo) {
    set(styleToApply, 'opacity', 0.75);
    set(styleToApply, 'zIndex', 10);
  } else {
    set(styleToApply, 'opacity', 0);
    set(styleToApply, 'zIndex', -10);
  }
  if (!isNil(videoContainer) && !isEmpty(videoContainer)) {
    forEach(styleToApply, (value, key) => {
      videoContainer.style[key] = value;
    });
  }
};

export default setVideoStyle;
